<template>
  <div>
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  import {mapState, mapActions, mapMutations} from 'vuex'
  export default {
    name: 'App',
    computed:{
      ...mapState(['lang'])
    },
    components: {
      Header,
      Footer
    },
    mounted() {
      if(!localStorage.getItem("lang")){
        localStorage.setItem("lang", "esp")
        this.updateLang('esp')
      }
      else{
        this.updateLang(localStorage.getItem("lang"))
      }
    },
    methods: {
      ...mapMutations(['updateLang'])
    }
  }
</script>

<style>
  @font-face {
    font-family: 'sailec';
    src: url('assets/fonts/SAILEC.otf');
  }
  @font-face {
    font-family: 'sailecBlack';
    src: url('assets/fonts/SAILEC-BLACK.otf');
  }
  @font-face {
    font-family: 'sailecBold';
    src: url('assets/fonts/SAILEC-BOLD.otf');
  }
  @font-face {
    font-family: 'sailecLight';
    src: url('assets/fonts/SAILEC-LIGHT.otf');
  }
  *{
    margin: 0;
    padding: 0;
    font-family: 'sailec';
  }
  body{
    overflow-x: hidden!important;
  }
  .content{
    width: 85%;
    margin: 0 auto;
  }
  h2{
    color: #383838;
    font-family: 'sailecBlack';
    margin: 0;
    font-size: 24pt!important;
  }
  h3{
    color: #00B5C0;
    font-family: 'sailecBold';
    text-align: center;
  }
  p{
    margin: 0;
    color: #383838;
    font-size: 11pt;
  }
  .btn{
    border: none!important;
    outline: none!important;
  }
  .body:before{
    display: block;       
    content: "";      
    height: 85.58px;       
    visibility: hidden; 
  }
  .ancla{
    position: absolute;
    top: -15.58px;
  }
   .titulo{
        margin-bottom: 50px;
        text-align: center;
    }
    .titulo .linea{
        width: 100%;
        height: 1px;
        background-color: rgba(96, 96, 96, 0.5);
    }
    .titulo .row{
        align-items: center;
    }
    .titulo p{
        text-transform: uppercase;
        letter-spacing: 8px;
        font-family: 'sailecBold';
        color: #606060;
        font-size: 10pt;
    }

  @media screen and (max-width: 991px){
    .body:before{
      height: 52.4px;
    }
    .ancla{
      top: 0;
    }
  }

  @media screen and (max-width: 767px){
    .content{
      width: 90%;
    }
    h2{
      font-size: 20pt!important;
    }
    h3{
      font-size: 16pt!important;
    }
    .titulo .lineaIzquierda{
      margin-bottom: 20px;
    }
    .titulo .lineaDerecha{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue